<template>
  <content-box class="confirm-my-page--wrap" :width="'530px'">
    <p class="title">
      <template v-if="isNew">
        {{ $t('common.planSubscription') }}
      </template>
      <template v-else>
        {{ $t('userInfo.managePlan.confirmMyPage.title') }}
      </template>
    </p>
    <div class="desc--wrap">
      <template v-if="downgradeMore === 'funnel'">
        <p class="sub-title" v-html="$t('userInfo.managePlan.confirmMyPage.funnel.title')"></p>
        <p class="desc" v-html="$t('userInfo.managePlan.confirmMyPage.funnel.desc')"></p>
      </template>
      <template v-if="downgradeMore === 'bLogin'">
        <p class="sub-title" v-html="$t('userInfo.managePlan.confirmMyPage.bLogin.title')"></p>
        <p class="desc" v-html="$t('userInfo.managePlan.confirmMyPage.bLogin.desc')"></p>
      </template>
    </div>
    <div class="table--wrap">
      <table v-if="downgradeMore === 'funnel'">
        <thead>
          <tr>
            <th width="267px" class="name">{{ $t('common.table.header.funnel') }}</th>
            <th width="90px" class="funnel-before">{{ $t('common.table.header.before') }}</th>
            <th width="113px" class="funnel-after">{{ $t('common.table.header.after') }}</th>
          </tr>
        </thead>
        <tbody :class="{ 'empty': !hasItems }">
          <template v-if="hasItems">
            <tr v-for="(item, index) in contentList" :key="index">
              <td width="257px" class="name">
                <div class="ellipsis" style="width: 257px;">{{ item.name }}</div>
              </td>
              <td width="98px" class="funnel-before funnel-state" :class="item.state">
                {{ $t(`funnel.state.${item.state}`) }}
              </td>
              <td width="105px" class="funnel-after">{{ $t(`funnel.state.stop`) }}</td>
            </tr>
          </template>
          <template v-else>
            <tr class='no-items'>
              <td colspan="3">
                <ui-loading-circle v-if="isLoading" />
                <p v-else>{{ $t('userInfo.managePlan.confirmMyPage.funnel.noList') }}</p>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <table v-if="downgradeMore === 'bLogin'">
        <thead>
          <tr>
            <th width="150px" class="name">{{ $t('common.table.header.page') }}</th>
            <th width="140px" class="thead__funnel-regi">
              <span class="tooltip__blogin">
                <span v-html="$t('common.table.header.funnelRegi')"></span>
                <ui-icon-tooltip arrowCenter>
                  <span v-html="$t('userInfo.managePlan.confirmMyPage.bLogin.tooltip')"></span>
                </ui-icon-tooltip>
              </span>
            </th>
            <th width="98px" class="login-before">{{ $t('common.table.header.before') }}</th>
            <th width="73px" class="login-after">{{ $t('common.table.header.after') }}</th>
          </tr>
        </thead>
        <tbody :class="{ 'empty': !hasItems }">
          <template v-if="hasItems">
            <tr v-for="(item, index) in contentList" :key="index">
              <td width="150px" class="name">
                <div class="ellipsis" style="width: 140px;">{{ item.pageName }}</div>
              </td>
              <td width="140px" class="data__in-funnel">
                <i v-if="item.inFunnel" class="icon icon--check-green-size20"></i>
              </td>
              <td width="98px" class="bLogin-state" :class="item.state">
                {{ $t(`page.state.${item.state}`) }}
              </td>
              <td width="73px" class="after">{{ $t('page.state.stop') }}</td>
            </tr>
          </template>
          <template v-else>
            <tr class='no-items'>
              <td colspan="4">
                <ui-loading-circle v-if="isLoading" />
                <p v-else>{{ $t('userInfo.managePlan.confirmMyPage.bLogin.noList') }}</p>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <ui-button
      :primary3="true"
      :iconName="'icon--arrow-gray-size16'"
      @click="onCloseLayer">{{ $t('common.back') }}</ui-button>
  </content-box>
</template>

<script>
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'
import UiIconTooltip from '@/components/ui/UiIconTooltip'
import { checkBeforeDownGrade } from '@/api/userPlan'

export default {
  components: {
    UiLoadingCircle,
    ContentBox,
    UiButton,
    UiIconTooltip
  },
  props: [
    'downgradeMore',
    'planData'
  ],
  data () {
    return {
      isLoading: true,
      contentList: null,
      sortColumn: 'date',
      isSortAsc: false
    }
  },
  computed: {
    hasItems () {
      return this.contentList && this.contentList.length
    },
    isNew () {
      return this.planData.canCreate
    }
  },
  methods: {
    onCloseLayer () {
      this.$emit('update:downgradeMore', null)
    }
  },
  created () {
    checkBeforeDownGrade(this.downgradeMore).then(data => {
      this.isLoading = false
      let items = data

      if (items && this.downgradeMore === 'funnel') {
        items = items.filter(item => ['start', 'ing'].includes(item.state))
      }
      this.contentList = items
    })
  }
}
</script>

<style lang="scss" scoped="scoped">
.confirm-my-page--wrap {
  padding: 30px;
  box-sizing: border-box;
  .title {
    font-size: 15px;
    font-weight: 600;
    color: #2f2f2f;
  }
  .desc--wrap {
    @include flexXbetween;
    font-size: 13px;
    line-height: 1.46;
    color: #666666;
    margin-top: 40px;

    .sub-title {
      font-weight: 600;
    }
    .desc {
      width: 345px;
    }
  }

  .table--wrap {
    margin-top: 20px;
    position: relative;

    &:after {
      position: absolute;
      left: 0;
      bottom: 0;
      display: inline-block;
      content: '';
      width: 100%;
      height: 6px;
      background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.06), rgba(0, 0, 0, 0));
    }

    table {
      text-align: center;
      table-layout: fixed;
      border-collapse: collapse;

      thead {
        tr {
          display: block;
          background-color: #555;
          th {
            position: relative;
            height: 40px;
            color: #fff;
            line-height: 1.23;
            box-sizing: border-box;

            &:first-of-type:before,
            &:last-of-type:before {
              content: "";
              display: inline-block;
              width: 15px;
              height: 40px;
              position: absolute;
              top: 0;
              left: -5px;
              background-color: #555;
              border-radius: 5px;
            }

            &:last-of-type:before {
              left: auto;
              right: -5px;
            }

            &.name {
              text-align: left;
              padding-left: 10px;
            }

            &.thead__funnel-regi {
              padding-left: 10px;
              text-align: left;

              .tooltip__blogin {
                position: relative;
                display: inline-block;

                /deep/ .tooltip {
                  @include positionYcenter;
                  left: calc(100% + 8px);

                  .icon {
                    width: 16px;
                    height: 16px;
                    background-image: url(../../../assets/img/icon_alert_triangle_size16.svg);
                  }

                  .text {
                    text-align: left;
                  }
                }
              }
            }

            &.funnel-after {
              text-indent: -10px;
            }
          }
        }
      }
    }

    tbody {
      display: block;
      width: 100%;
      height: 215px;
      overflow-y: scroll;
      tr {
        height: 60px;
        border-bottom: 1px solid #ebebeb;
      }

      td {
        &.name {
          text-align: left;
          padding-left: 10px;
          font-size:14px;
          font-weight: 600;
          color: #2f2f2f;
        }
        &.funnel-state {
          font-size: 13px;
          font-weight: 600;

          &.start {
            color: $stateRunColor;
          }
          &.ing {
            color: $stateAnalyzingColor;
          }
          &.stop {
            color: $stateStopColor;
          }
          &.deleted {
            color: $errorColor;
          }
        }
        &.bLogin-state {
          font-size: 13px;
          font-weight: 600;
          &.run {
            color: $stateRunColor;
          }
          &.analyzing {
            color: $stateAnalyzingColor;
          }
        }
        &.funnel-after,
        &.login-after {
          font-size: 13px;
          color: #666;
        }
      }
      .no-items {
        display: block;
        height: 100%;
        text-align: center;

        & > td {
          box-sizing: border-box;
          display: block;
          width: 100%;
          height: 100%;
          padding-top: 90px;
          text-align: center;
          font-size: 14px;
          color: #767676;
        }

        .loading {
          margin-top: 30px;
        }
      }

      &.empty {
        overflow: hidden;
      }
    }
  }

  /deep/ .ui-btn {
    display: block;
    margin: 20px auto 0;
    font-size: 14px;
    font-weight: 600;
    color: #444444;
  }
}
</style>
